import styled from 'styled-components';

import { max } from '../../utils/breakpoints';

const StyledVerifyBody = styled.div`
  text-align: left;
  margin-left: 90px;

  p {
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${max.sm} {
    text-align: center;
    margin-left: 0;
  }
`;

export default StyledVerifyBody;
